export default __webpack_public_path__ + "static/media/91_desktop.d085219a.jpg";